import Api from '../Api/Api';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

function LandingPage() {
  const [content, setContent] = useState({});
  const navigate = useNavigate();

  const getLandingPageContent = async()=>{
    try {
      const res = await Api.get("/user/get-all-contents");
      // console.log(
      //   "11",
      //   res.data.result.filter((item) => item.title === "Landing Page")[0]
      // );
      setContent(
        res.data.result.filter(
          (item) => item.title === "Landing Page"
        )[0]
      );
    } catch (error) {
      console.log("err",error)
    }
  }
 useEffect(()=> {
  getLandingPageContent();
 }, [])
  return (
    <>
      <div className="main-container">
        <div
          style={{
            backgroundImage: "url('assets/images/background/bg.png')",
            objectFit: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            // border: "2px solid red",
            backgroundColor: "#132761",
            height: "100vh",
            width: "100%",
            // paddingTop: "40vh",
            // textAlign: "center",
            backgroundSize: "100% 100%",
          }}
        >
          <div style={{ padding: "2%", cursor: "pointer", color: "#d1cccc" }}>
            <i class="fa fa-arrow-left" onClick={() => navigate("/")}></i>
          </div>
          <div
            className="heading"
            style={{
              // alignContent: "center",
              color: "white",
              paddingTop: "30vh",
              textAlign: "center",
              // fontSize:"larger"
            }}
            dangerouslySetInnerHTML={{ __html: content?.description }}
          >
            {/* <h1 style={{ fontFamily: "Georgia, serif" }}></h1> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default LandingPage